import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from '@ui/shared/feature-config';
import type { ProjectListItemModel } from './app/definitions/project-list-item.model';
import type { ProjectListFilter } from './app/types/project-list-filters';
import { ProjectListMapDataService } from './app/services/project-list-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { ProjectListVenueMapDataService } from './app/services/data/project-list-venue-map-data.service';
import { DistrictSelectFilterConfigService } from './app/services/filter/district-select-filter-config.service';
import { SpecialUsageKindSelectFilterConfigService } from './app/services/filter/special-usage-kind-select-filter-config.service';

bootstrapApplication(AppComponent, createAppConfig<ProjectListItemModel, ProjectListFilter>({
    mapDataStateService: ProjectListMapDataService,
    filterItems: [
        SearchFilterConfigService,
        DistrictSelectFilterConfigService,
        SpecialUsageKindSelectFilterConfigService,
    ],
    dataEndpoints: [
        ProjectListVenueMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
